const styles = {
  container: {
    height: "40px",
    width: "212px",
    borderRadius: "4px",
    backgroundColor: "#FFFFFF",
    boxShadow: "0 2px 4px 0 rgba(0,0,0,0.2)",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    position: "fixed",
    zIndex: "800",
    bottom: "10px",
    left: "15px",
    "@media (max-width: 1200px)": {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      height: "58px",
      bottom: "15px",
      left: "8px",
      width: "108px",
    },
  },
  campusMap: {
    height: "35px",
    width: "108px",
    color: (props: any) =>
      props.currentView === "mapview" &&
      props.searchbarOption !== "destinations"
        ? "rgba(99,115,164,0.4)"
        : "#6373A4",
    fontFamily: ({ theme }) => theme.fontFamily,
    fontSize: "14px",
    letterSpacing: "0",
    lineHeight: "24px",
    cursor: "pointer",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: (props: any) =>
      props.currentView === "campusmap" ? "900" : "500",
    backgroundColor: (props: any) =>
      props.currentView === "campusmap" ? "#F1F3F4" : "",
    pointerEvents: (props: any) =>
      props.searchbarOption !== "destinations" ? "none" : "auto",
  },
  mapView: {
    height: "35px",
    width: "108px",
    color: "#6373A4",
    fontFamily: ({ theme }) => theme.fontFamily,
    fontSize: "14px",
    letterSpacing: "0",
    lineHeight: "24px",
    textAlign: "center",
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: (props: any) =>
      props.currentView === "mapview" ? "900" : "500",
    backgroundColor: (props: any) =>
      props.currentView === "mapview" ? "#F1F3F4" : "",
  },
};

export default styles;
